// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button_wrapper__9t2m0","primary":"button_primary__3Ajsj","btn-disabled":"button_btn-disabled__2aj9F"};